













































import { GraphsDTO } from '@/services/dashboard/types'
import { BarChart, PieChart } from 'echarts/charts'
import { GridComponent, LegendComponent, TitleComponent, TooltipComponent } from 'echarts/components'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import moment from 'moment'
import Vue from 'vue'
import VChart from 'vue-echarts'

use([CanvasRenderer, PieChart, BarChart, GridComponent, TitleComponent, TooltipComponent, LegendComponent])

const PIE_PALETTE = ['#36a7aa', '#7c63d3']
const BAR_PALETTE = ['#36a7aa', '#7c63d3']

export default Vue.extend({
  name: 'HomeGraphs',
  components: { VChart },
  props: {
    graphData: { type: Array as () => GraphsDTO[], default: () => [] },
  },
  computed: {
    pieData(): GraphsDTO | null {
      return this.graphData[0] || null
    },
    barData(): GraphsDTO | null {
      return this.graphData[1] || null
    },
    hasPieData(): boolean {
      if (!this.pieData) return false
      const a = Number(this.pieData.listItems[0]?.value?.sum) || 0
      const b = Number(this.pieData.listItems[1]?.value?.sum) || 0
      return a + b > 0
    },
    hasBarData(): boolean {
      if (!this.barData) return false
      const buy = (this.barData.listItems[0]?.value as unknown as number[]) || []
      const sell = (this.barData.listItems[1]?.value as unknown as number[]) || []
      return [...buy, ...sell].some(v => Number(v) > 0)
    },
    firstGraphOptions(): any { // eslint-disable-line
      const pie = this.pieData
      const buyName = pie ? this.$t(pie.listItems[0].value.p_type) : ''
      const sellName = pie ? this.$t(pie.listItems[1].value.p_type) : ''
      return {
        color: PIE_PALETTE,
        tooltip: { trigger: 'item', formatter: '{b}: {c} MW ({d}%)' },
        legend: {
          orient: 'horizontal',
          bottom: 0,
          icon: 'circle',
          itemWidth: 10,
          itemHeight: 10,
          textStyle: { color: '#475569', fontSize: 12 },
          data: [buyName, sellName],
        },
        series: [
          {
            name: this.$tc('boughtSoldEnergy'),
            type: 'pie',
            radius: ['52%', '72%'],
            center: ['50%', '46%'],
            avoidLabelOverlap: true,
            itemStyle: { borderRadius: 6, borderColor: '#fff', borderWidth: 2 },
            label: { show: false },
            labelLine: { show: false },
            data: [
              { value: pie ? pie.listItems[0].value.sum : 0, name: buyName },
              { value: pie ? pie.listItems[1].value.sum : 0, name: sellName },
            ],
            emphasis: {
              scale: true,
              scaleSize: 4,
              itemStyle: { shadowBlur: 8, shadowColor: 'rgba(15, 23, 42, 0.12)' },
            },
          },
        ],
      }
    },
    secondGraphOptions(): any { // eslint-disable-line
      const bar = this.barData
      return {
        color: BAR_PALETTE,
        grid: { left: 40, right: 16, top: 24, bottom: 60, containLabel: true },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          valueFormatter: (v: number) => `${v} MW`,
        },
        legend: {
          bottom: 0,
          icon: 'circle',
          itemWidth: 10,
          itemHeight: 10,
          textStyle: { color: '#475569', fontSize: 12 },
          data: [this.$tc('buy'), this.$tc('sell')],
        },
        xAxis: {
          type: 'category',
          axisTick: { alignWithLabel: true, lineStyle: { color: '#e2e8f0' } },
          axisLine: { lineStyle: { color: '#e2e8f0' } },
          axisLabel: { color: '#64748b', fontSize: 11 },
          data: this.weekDates(),
        },
        yAxis: {
          type: 'value',
          position: 'left',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { lineStyle: { color: '#f1f5f9' } },
          axisLabel: { formatter: '{value} MW', color: '#64748b', fontSize: 11 },
        },
        series: [
          {
            name: this.$tc('buy'),
            type: 'bar',
            barMaxWidth: 28,
            itemStyle: { borderRadius: [4, 4, 0, 0] },
            data: bar ? bar.listItems[0].value : [],
          },
          {
            name: this.$tc('sell'),
            type: 'bar',
            barMaxWidth: 28,
            itemStyle: { borderRadius: [4, 4, 0, 0] },
            data: bar ? bar.listItems[1].value : [],
          },
        ],
      }
    },
  },
  methods: {
    weekDates() {
      const date = new Date()
      date.setDate(date.getDate() - 29)
      const weeks: string[] = []
      for (let i = 1; i < 5; i++) {
        date.setDate(date.getDate() + 1)
        const firstDate = moment(date).format('DD MMM')
        date.setDate(date.getDate() + 6)
        const secondDate = moment(date).format('DD MMM')
        weeks.push(firstDate + '-' + secondDate)
      }
      return weeks
    },
  },
})
